module.exports = __webpack_public_path__ + "static/media/reduce_decimal_places.84398e6f.svg";